module.exports = __webpack_public_path__ + "img/enotas.6fc5be32.png";